import React from "react";
import { Avatar, Card, Tooltip } from "antd";
import { FormattedMessage } from "react-intl";

import ChatDescription from "../ChatDescription";
import ChatItemOptions from "./ChatItemOptions";

import DefaultGroupImage from "../../assets/img/avatar_group_black.png";
import DefaultUserImage from "../../assets/img/avatar_user_black.png";

import "./ChatItem.scss";

const { Meta } = Card;

function getChatPrivacy(item) {
  const elements = item.elements || item.draft?.elements || [];

  const privacyElement = elements.find(
    (elem) => elem.description === window.Social.getChatConfig().privacyElement
  );

  if (privacyElement?.content) {
    const privacyModel = Object.values(
      window.Social.getPrivacyTypesConfig() || {}
    ).find((elem) => elem.value === privacyElement.content);

    if (privacyModel && !privacyModel.hiddenOnDescription) {
      return privacyModel;
    }
  }

  const privateChat = window.Social.getPrivacyTypesConfig().find(
    (elem) => elem.value === "DESTINATARIOS"
  );

  return privateChat;
}

function getItemTitle(item, flags, mentions, formatMessage, isChatUnread) {
  const currentFlag = flags.find(
    (elem) => elem.id === (item.flags && item.flags[0] && item.flags[0].id)
  );

  const archivedPrefix =
    (currentFlag && currentFlag.alternativeArchivedPrefix) ||
    "chat.archivedPrefix";

  const maxLength = 30;

  let descriptionText = "";

  if (item.description) {
    descriptionText =
      mentions && mentions[item.id] ? `(${mentions[item.id]}) ` : "";

    descriptionText += item.archived
      ? `${formatMessage({ id: archivedPrefix })} ${item.description}`
      : item.description;
  } else {
    descriptionText =
      mentions && mentions[item.id] ? `(${mentions[item.id]}) ` : "";

    const hasOtherRecipients = item.recipients.length - 1 > 0;

    descriptionText += formatMessage(
      {
        id: hasOtherRecipients
          ? "chat.noDescriptionTitle"
          : "chat.noDescriptionTitleNoOthers",
      },
      {
        name: item.createdBy.username,
        archived: item.archived ? formatMessage({ id: archivedPrefix }) : "",
        ...(hasOtherRecipients && { number: item.recipients.length - 1 }),
      }
    );
  }

  if (descriptionText.length > maxLength) {
    return (
      <Tooltip title={descriptionText} overlayClassName="social-tooltip">
        <span
          className={`chat-item-title ${isChatUnread(item) ? "unread" : ""}`}
        >
          {descriptionText}
        </span>
      </Tooltip>
    );
  }

  return (
    <span className={`chat-item-title ${isChatUnread(item) ? "unread" : ""}`}>
      {descriptionText}
    </span>
  );
}

function getItemAvatar(item) {
  let avatar;

  if (item.recipients.length === 2) {
    avatar = DefaultUserImage;
  } else {
    avatar = DefaultGroupImage;
  }

  const privacy = getChatPrivacy(item);

  return (
    <div className="chat-item-avatar">
      <Avatar src={avatar} />

      {privacy && (
        <div className="chat-privacy-badge">
          <FormattedMessage id={privacy.title} />
        </div>
      )}
    </div>
  );
}

function ChatItem({
  item,
  flags,
  mentions,
  formatMessage,
  isChatUnread,
  optionBoxOpenId,
  optionBoxDirection,
  setOptionBoxRef,
  toggleOptionsBox,
  archiveChat,
  emitEvent,
  onOptionDivClick,
}) {
  return (
    <Card
      bordered={false}
      className={`chat-item ${isChatUnread(item) ? "unread" : ""}`}
    >
      <Meta
        avatar={getItemAvatar(item)}
        title={getItemTitle(item, flags, mentions, formatMessage, isChatUnread)}
        description={<ChatDescription chat={item} flags={flags} />}
      />

      <ChatItemOptions
        chat={item}
        unread={isChatUnread(item)}
        timestamp={item.lastMessageDate}
        flags={flags}
        setOptionBoxRef={setOptionBoxRef}
        optionBoxDirection={optionBoxDirection}
        toggleOptionsBox={toggleOptionsBox}
        archiveChat={archiveChat}
        formatMessage={formatMessage}
        emitEvent={emitEvent}
        optionBoxOpenId={optionBoxOpenId}
        onOptionDivClick={onOptionDivClick}
      />
    </Card>
  );
}

export default ChatItem;
